import type { App as VueApp, Plugin } from "vue";

import ProcessList from "@PrivateArea/Scripts/Components/ProcessList/ProcessList.vue";
import ProjectFilterBox from "@PrivateArea/Scripts/Components/ProjectFilterBox/ProjectFilterBox.vue";
import AssetFilterBox from "@PrivateArea/Scripts/Components/AssetFilterBox/AssetFilterBox.vue";
import AssetProfileRelationList from "@PrivateArea/Scripts/Components/AssetProfileRelationList/AssetProfileRelationList.vue";
import AssetBundleEmail from "@PrivateArea/Scripts/Components/AssetBundleEmail/AssetBundleEmail.vue";
import ServiceTerms from "@PrivateArea/Scripts/Components/ServiceTerms/ServiceTerms.vue";
import ProfileFavoriteList from "@PrivateArea/Scripts/Components/ProfileFavorite/ProfileFavoriteList.vue";
import AddProfileFavorite from "@PrivateArea/Scripts/Components/ProfileFavorite/AddProfileFavorite.vue";

import ProjectAssociation from "@PrivateArea/Scripts/Components/ProjectAssociation/ProjectAssociation.vue";

import AccountLogout from "@Account/Scripts/Components/Account/AccountLogout.vue";
import ToastHub from "@Account/Scripts/Components/Toast/ToastHub.vue";
import CookieToast from "@Scripts/Components/CookieToast/CookieToast.vue";

const AppConfig: Plugin = {
	install(app: VueApp) {
		app.component("app-process-list", ProcessList);
		app.component("app-project-filterbox", ProjectFilterBox);
		app.component("app-asset-filterbox", AssetFilterBox);
		app.component("app-asset-profilerelation-list", AssetProfileRelationList);
		app.component("app-asset-bundleemail", AssetBundleEmail);
		app.component("app-serviceterms", ServiceTerms);
		app.component("app-profilefavoritelist", ProfileFavoriteList);
		app.component("app-addprofilefavorite", AddProfileFavorite);

		app.component("app-projectassociation", ProjectAssociation);

		app.component("app-accountlogout", AccountLogout);
		app.component("app-toasthub", ToastHub);
		app.component("app-cookietoast", CookieToast);
	}
};

export default AppConfig;